export default __webpack_public_path__ + "static/media/HT3.jpg";